import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_maintenance_details_report = () => {
  useAuthRedirect();
  const { id, branch } = useParams(); 
  const [vehicleResult, setVehicle] = useState([]);
  const [header, setHeader] = useState({});
  const [cum, setCum] = useState({});
  const [loading, setLoading] = useState(false);
  const canView  = hasPermission("Vehicle maintenance - Report", "view");



 useEffect(() => {
  const fetchVehicleFullReport = async () => {
    let progress = 0;

    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Loading Vehicle Details",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      // 1. Vehicle Main Details
      const mainRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_report_api/${id}`);
      setVehicle(mainRes.data.vehicles || []);
      progress = 33; updateProgress(progress);

      // 2. Header Details
      const headerRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_reportheader_api?vcode=${id}&branch=${branch}`);
      if (headerRes.data?.headerDetails?.length > 0) {
        const items = headerRes.data.headerDetails;
        const storeReqHeader = {
          vehicle_type: items[0].vehicle_type || "N/A",
          vehicle_name: items[0].vehicle_name || "N/A",
          vehicle_code: items[0].vehicle_code || "N/A",
          vehicle_number: items[0].vehicle_number || "N/A",
        };
        setHeader(storeReqHeader);
      }
      progress = 66; updateProgress(progress);

      // 3. Cumulative Totals
      const cumRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_cumulative_api?vcode=${id}`);
      if (cumRes.data?.cumulativeHrs?.length > 0) {
        const items = cumRes.data.cumulativeHrs;
        const storeReqHeader = {
          total_combined: items[0].total_combined || "N/A",
        };
        setCum(storeReqHeader);
      }

      progress = 100; updateProgress(progress);
      setTimeout(() => Swal.close(), 500);

    } catch (error) {
      console.error("Error loading vehicle report:", error);
      Swal.fire({
        icon: "error",
        title: "Load Failed",
        text: "Something went wrong while fetching vehicle details.",
      });
    }
  };

  if (id && branch) {
    {canView && (
    fetchVehicleFullReport()
    )}
  }
}, [id, branch]);

if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
                      <h2 className="add-txt">Vehicle Maintenance - Details</h2>
                      <Link to={`/vehicle_maintenance_report`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                      </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vehicle_code" value={header.vehicle_code} readOnly/>

              </div>
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="vehicle_type" value={header.vehicle_type} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vehicle_name" value={header.vehicle_name} readOnly />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehicle_number" value={header.vehicle_number} readOnly />
              </div>
            </div>           
            
            <div className="content-table">
            <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
      <th>Oil Grade</th>
      <th>Capacity</th>
      <th>Part Number</th>
      <th>Changing Hours</th>
      <th>Last Changed Hour</th>
      <th>Now</th>
      <th>Remaining-Hours</th>
      <th>Alerts</th>
    </tr>
  </thead>
  <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" className="text-center">Loading... Please wait</td>
    </tr>
  ) : vehicleResult.length > 0 ? (
    vehicleResult.map((item, index) => {
      const starting_hrs = item.starting_hrs ? parseFloat(item.starting_hrs) : 0;
      const working_hrs = cum.total_combined ? parseFloat(cum.total_combined) : 0;
      const nowReached = working_hrs !== 0 ? working_hrs - starting_hrs : working_hrs;

      const changing_hrs = item.changing_hrs ? parseFloat(item.changing_hrs) : 0;
      const last_modified_hr = item.last_modified_hr ? parseFloat(item.last_modified_hr) : 0;
      const tot = changing_hrs + last_modified_hr;

      const remaining = tot > nowReached ? (tot - nowReached).toFixed(2) : "Level Crossed";
      const showAlert = tot < (nowReached + 5);

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.fld_Descriptions}</td>
          <td>{item.oilgrade}</td>
          <td>{item.capacity}</td>
          <td>{item.partNumber}</td>
          <td>{item.changing_hrs}</td>
          <td>{item.last_modified_hr}</td>
          <td>{nowReached.toFixed(2)}</td>
          <td>{remaining}</td>
          <td>{showAlert && <h3>Need to Change</h3>}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="10">No Data Available</td>
    </tr>
  )}
</tbody>

</table>
            </div>
          </form>
        </div>

      
      </div>
    </div>
  );
};

export default Vehicle_maintenance_details_report;
